<template>
  <div class="progress-bar">
    <div
      class="progress-fill"
      :style="{ width: `${progress}%`, background: progressColor }"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    length: {
      type: Number,
      required: true,
    },
    redColorValue: {
      type: Number,
      required: true,
    },
  },
  computed: {
    progress() {
      return this.length;
    },
    progressColor() {
      return this.length - this.redColorValue ? "red" : "green";
    },
  },
};
</script>

<style scoped>
.progress-bar {
  height: 20px;
  background-color: #eee;
  border-radius: 5px;
}

.progress-fill {
  height: 100%;
  border-radius: 5px 0 0 5px;
}
</style>
